import firebase from 'firebase/app'
import 'firebase/storage';
import 'firebase/firestore'

// Get a Firestore instance
const firebaseApp = firebase
    .initializeApp({
        apiKey: "AIzaSyCIKqv5RTmxadPSiI90hZQs4fmVJV-50ps",
        authDomain: "cmu-hms.firebaseapp.com",
        databaseURL: "https://cmu-hms.firebaseio.com",
        projectId: "cmu-hms",
        storageBucket: "cmu-hms.appspot.com",
        messagingSenderId: "944680735149",
        appId: "1:944680735149:web:0435b3e66152f9de0d1124",
        measurementId: "G-W7TGWPLMNX"
    });


const db = firebase.firestore();
const storage = firebase.storage();



export { db, storage };


// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore
export { Timestamp, GeoPoint }

